import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { HeaderBarComponent } from './header-bar/header-bar.component';
import { DeleteModalComponent } from './delete-modal/delete-modal.component';
import { ImportModalComponent } from './import-modal/import-modal.component';
import { HeaderDataComponent } from './header-data/header-data.component';
import { OrderByPipe } from 'src/app/Services/order-by.pipe';
import { ImportErrorFileComponent } from './import-error-file/import-error-file.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgxPaginationModule } from 'ngx-pagination';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { SpinnerInterceptor } from 'src/app/Services/Interceptors/spinner.interceptors';
import { NgBusyModule } from 'ng-busy';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';


const importsModules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  NgxSpinnerModule,
  RouterModule,
  NgBusyModule,
  NgMultiSelectDropDownModule,
  NgxPaginationModule,
  NgbTooltipModule
];

const prSharedComponents = [HomeComponent, HeaderBarComponent, HeaderDataComponent, DeleteModalComponent, ImportModalComponent,
  OrderByPipe, ImportErrorFileComponent];

@NgModule({
  imports: [...importsModules],
  declarations: [...prSharedComponents],
  exports: [...importsModules, ...prSharedComponents],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule { }
